export default __webpack_public_path__ + "fonts/icon-size.1a641f8824984c82d5b56a69e9fcf6d3.png";